import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import { themeStructure } from "@vcl";
import { compileSpacingSides } from "%/dynamic-component-editor/helpers/spacing-sides";

export const MARGIN_DEFAULT_EMPTY_VALUE = "none";

export default class Margins extends BaseOption {

  static userInterfaceComponent = {
    label: "Margins",
    component: inspectorTools.SPACING_PICKER,
    useCustomLabel: true,
    useVerticalOrientation: true,
    useDefaultVariableLinking: false,
    canSetOtherStates: [BaseOption.$states.HOVER],
    props: {
      options: themeStructure.size.spacing,
      heading: this.label,
    },
  };

  static defaultValue = {
    top: null,
    right: null,
    bottom: null,
    left: null,
  };

  static convertConfigValueToCompiledValue(configValue, themeId = null, themeMode = null) {
    return compileSpacingSides("margins", configValue, Object.keys(this.defaultValue), alias => BaseOption._getStyleValuePropertiesFromTheme("size.spacing", themeId, themeMode, alias));
  }

  static convertValueToStringForTransactionLog(compiledValue) {
    return `Top: ${compiledValue?.top || "none"}, Right: ${compiledValue?.right || "none"}, Bottom: ${compiledValue?.bottom || "none"}, Left: ${compiledValue?.left || "none"}`;
  }
}
